import moment from 'moment'
export const addInvoiceMixin = {
  methods: {
    getBuyerFromId(id) {
      return this.exporterData.clients_locked.find((element) => {
        return id === element.importer_user_id
      })
    },
    navigate(component, id, value) {
      this.$router
        .push({
          name: component,
          params: {
            id: id || '',
            value: value || ''
          }
        })
        .catch(() => {})
    },
    setDates() {
      Object.keys(this.dates).forEach((key) => {
        this.form[key] = moment(this.dates[key], this.options.format).format(
          'DD-MM-YYYY'
        )
      })
    },
    getDates(data) {
      Object.keys(this.dates).forEach((key) => {
        if (data[key]) {
          this.dates[key] = moment(data[key]).format('DD/MM/YYYY')
        }
      })
    }
  },
  directives: {
    tabindex: {
      inserted(el) {
        el.setAttribute('tabindex', 0)
      }
    }
  }
}
